import HttpClient from '@/services/HttpClient';

export default class InvoiceService {

	constructor(token,podUrl) {
		this.token = token;
		this.podUrl = podUrl;
		this.httpClient = new HttpClient(podUrl, false);
	}

	getSignedUrl(fileName) {
		return this.httpClient
			.get(`/api/docs/invoice/files`, {
				params: {
					token: this.token,
					fileName: fileName
				},
			})
			.then((res) => Promise.resolve(res))
			.catch((err) => Promise.reject(err));
	}

	downloadInvoice(theme){
		return this.httpClient
			.get(`/api/docs/invoice/download`, {
				params: {
					token: this.token,
					theme,
				},
				responseType: 'blob',
			})
			.then((res) => Promise.resolve(res))
			.catch((err) => Promise.reject(err));
	}

	// Plain link (not an XHR) so the API's Content-Disposition decides view vs. download.
	getReceiptUrl(invoiceItemId, fileName) {
		const params = new URLSearchParams({ token: this.token, itemId: invoiceItemId, fileName: fileName });
		return `${this.podUrl.replace(/\/$/, '')}/api/docs/invoice/receipt?${params}`;
	}

	getInvoiceItem(clientId, invoiceId, invoiceItemId) {
		return this.httpClient
			.get(`/api/docs/invoice/item/${invoiceItemId}`, {
				params: {
					token: this.token
				},
			})
			.then((res) => Promise.resolve(res))
			.catch((err) => Promise.reject(err));
	}

}
